import React, { useEffect, useRef, useState } from 'react';
import { openPopup } from '../../data/sport-utils';
import { getBaseURL } from '../../data/utils/getBaseURL';
import { getCheckbetUrl } from '../../data/utils/getCheckbetUrl';
import { getConfiguration } from '../../data/utils/configuration';
import { REGEX_URL } from '../../data/utils';
import { getLabel } from '../../data/labels';
import { useCheckTicket } from './CheckTicketContext';

export default function CheckTicketModal() {
    const conf = getConfiguration();

    const checkTicket = useCheckTicket();

    const [showScannerType, setShowScannerType] = useState(false);

    function handleScan() {
        if (conf.mst === 'ALL') {
            setShowScannerType(true);
        } else if (conf.mst === 'BARCODE') {
            checkTicket.setScannerStarted(true, 'BARCODE');
        } else if (conf.mst === 'QRCODE') {
            checkTicket.setScannerStarted(true, 'QRCODE');
        }
    }

    function openCheckbet() {
        if (checkTicket.ticketId == null && inputRef.current.value === '') {
            return null;
        }

        const ticketId = inputRef.current.value || checkTicket.ticketId;
        let url;
        if (REGEX_URL.test(ticketId)) {
            url = ticketId;
        } else {
            const baseURL = getBaseURL();
            //const checkbetPage = getCheckbetPage(true);
            //url = `${baseURL.replace('xsport_desktop', 'xsport_mobile')}${checkbetPage}?ticket=${ticketId}&system_code=${systemCode}&language=${xs_languageCode}`;
            url = getCheckbetUrl(ticketId);
        }
     
        // always in mobile version, 'cause it is full resposive
        openPopup(url,getLabel('general.checkbet'), 400, 800);
    }

    const inputRef = useRef(null);
    useEffect(() => {
        if (checkTicket.ticketId) {
            inputRef.current.value = checkTicket.ticketId;
        }
    }, [checkTicket.ticketId]);

    if (showScannerType) {
        return (
            <div className="p-2">
                <div className="mt-3 mb-2 grid grid-cols-12 gap-2">
                    <button className="col-start-1 col-end-7 h-10 px-2 grid grid-cols-12 items-center bg-cs4 text-cs1 rounded-md" onClick={handleScan}>
                        <i className="col-start-1 col-end-3 bi-upc-scan fill-accent-5-contrast-1" />
                        <span className="col-start-3 col-end-13">{getLabel('check_ticket.scan.barcode')}</span>
                    </button>
                    <button className="col-start-7 col-end-13 h-10 px-2 grid grid-cols-12 items-center bg-cs4 text-cs1 rounded-md" onClick={handleScan}>
                        <i className="col-start-1 col-end-3 bi-upc-scan fill-accent-5-contrast-1" />
                        <span className="col-start-3 col-end-13">{getLabel('check_ticket.scan.qrcode')}</span>
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="p-2 text-cs9">
            <div className="my-2 grid grid-cols-12 gap-2 items-center">
                <label className="col-start-1 col-end-3 pl-1">{getLabel('general.id')}</label>
                <input className="h-8 col-start-3 col-end-13 px-2 bg-cs7 text-cs6 rounded-md" ref={inputRef} />
            </div>
            <div className="mt-3 mb-2 grid grid-cols-12 gap-2">
                <button className="col-start-1 col-end-7 h-10 px-2 grid grid-cols-12 items-center bg-cs4 text-cs1 rounded-md" onClick={handleScan}>
                    <i className="col-start-1 col-end-3 bi-upc-scan fill-accent-5-contrast-1" />
                    <span className="col-start-3 col-end-13">{getLabel('check_ticket.scan')}</span>
                </button>
                <button className="col-start-7 col-end-13 h-10 p-2 bg-cs4 text-cs1 rounded-md" onClick={openCheckbet}>{getLabel('check_ticket.check')}</button>
            </div>
        </div>
    );
}
